export const OBTENER_DATA_ROUTES = "obtener_data_rutas";
export const LOADING_DATA_ROUTES = "loading_data_rutas";
export const ERROR_DATA_ROUTES = "error_data_rutas";

export const CREATE_UPDATE_ROUTES = "actualizar_data_rutas";

export const OBTENER_DATA_ROUTES_CONTAINER = "obtener_data_rutas_contenedores";
export const LOADING_DATA_ROUTES_CONTAINER = "loading_data_rutas_contenedores";
export const ERROR_DATA_ROUTES_CONTAINER = "error_data_rutas_contenedores";
